import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  Box,
  Typography,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import PreLoader from '@/components/preLoader';
import InventorySearchInput from '@/components/inventorySearchInput'
import ReplenishStockSection from './ReplenishStockSection';

import { useMutation } from '@apollo/client';
import { UPDATE_PRODUCT } from '@/services/inventoryService'

import { useTranslation } from 'react-i18next'
import useStyles from './styles'

const REPLENISHED_STOCK_REASON_ID = '9fc7dd9e-efa0-4941-9df7-66a588bbbd74'

const ReplenishStock = ({ open, handleClose }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar();

  const [selectedProduct, setSelectedProduct] = useState(null)

  const [updateProductMutation, { loading: isUpdatingProduct }] = useMutation(UPDATE_PRODUCT, {
    onCompleted: () => {
      handleClose()
      enqueueSnackbar(t('workboard.add_stock.stock_adjusted'));
    },
    onError: (error) => {
      const errorMessage = error?.message || error?.errors[0].message;
      enqueueSnackbar(errorMessage, { variant: 'error' });
    }
  })

  const onReplenish = (fromStore, toStore, replenishAmount) => {
    var variables = {
      product: {
        name: selectedProduct.name, // mandatory input field for product update
        bar_code: selectedProduct.bar_code, // mandatory input field for product update
        category_id: selectedProduct.category_id, // mandatory input field for product update
        stocks: [
          {
            store_id: fromStore.id,
            stock_infos: {
              stock: -1 * replenishAmount,
              reason_id: REPLENISHED_STOCK_REASON_ID
            }
          },
          {
            store_id: toStore.id,
            stock_infos: {
              stock: replenishAmount,
              reason_id: REPLENISHED_STOCK_REASON_ID
            }
          }
        ]
      }
    }

    updateProductMutation({
      variables
    })
  }

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="alert-dialog-slide-title">
        <Grid
          container
          alignItems="center"
          justify="space-between"
          alignContent="center"
        >
          <Grid item xs={1} />
          <Grid className={classes.headerText} item xs={10}>
            {t('workboard.replenish_stock.replenish_stock')}
          </Grid>
          <Grid item xs={1} style={{ textAlign: 'right' }}>
            <IconButton
              onClick={handleClose}
              className={classes.closeButton}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>

        <Box marginY={9}>
          <Typography align='center' className={classes.enterBarcodeText}>
            {selectedProduct
              ? t('workboard.replenish_stock.select_from_to')
              : t('workboard.add_stock.enter_barcode_to_add_stock')
            }
          </Typography>
        </Box>

        {selectedProduct
          ?
          <ReplenishStockSection
            selectedProduct={selectedProduct}
            onRemoveProduct={() => setSelectedProduct(null)}
            onReplenish={onReplenish}
          />
          :
          <Box paddingX={10} paddingBottom={10} minHeight={300}>
            <InventorySearchInput
              onSelectInventory={setSelectedProduct}
            />
          </Box>
        }
      </DialogTitle>

      {isUpdatingProduct && <PreLoader size={35} />}
    </Dialog>
  )
}

export default ReplenishStock